export const HeartIcon = ({ isFavourite }: { isFavourite?: boolean | null }) => (
	<svg xmlns="http://www.w3.org/2000/svg" width="22" height="20" viewBox="0 0 22 20" fill="none">
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M10.7432 2.88777C8.7438 0.550353 5.40975 -0.0784043 2.90469 2.06197C0.399644 4.20234 0.0469677 7.78093 2.0142 10.3124C3.64982 12.4171 8.59977 16.8561 10.2221 18.2928C10.4036 18.4535 10.4944 18.5339 10.6002 18.5655C10.6926 18.593 10.7937 18.593 10.8861 18.5655C10.9919 18.5339 11.0827 18.4535 11.2642 18.2928C12.8865 16.8561 17.8365 12.4171 19.4721 10.3124C21.4393 7.78093 21.1297 4.17982 18.5816 2.06197C16.0335 -0.0558897 12.7425 0.550353 10.7432 2.88777Z"
			fill={isFavourite ? '#F04438' : '#FFFFFF'}
			fillOpacity={isFavourite ? 1 : 0.9}
			stroke={isFavourite ? '#FDA29B' : '#D5D7DA'}
			strokeWidth="1.5"
			strokeLinecap="round"
			strokeLinejoin="round"
			className="transition-colors duration-150"
		/>
	</svg>
);
